// src/redux/slices/navEditModeSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface NavEditModeState {
  isNavEditMode: boolean;
}

const initialState: NavEditModeState = {
  isNavEditMode: false,
};

export const navEditModeSlice = createSlice({
  name: 'navEditMode',
  initialState,
  reducers: {
    toggleNavEditMode: (state) => {
      state.isNavEditMode = !state.isNavEditMode;
    },
  },
});

export const {
  toggleNavEditMode,
} = navEditModeSlice.actions;

export default navEditModeSlice.reducer;
